import { Box as MuiBox } from "@mui/material";
import { DataGridPro as MuiDataGrid } from "@mui/x-data-grid-pro";
import { useTranslation } from "react-i18next";
import {
  getTableColumnHeaders,
  tableStyles,
} from "./EProtocolTableConfig";
import { LoadingGridOverlay, NoRowsGridOverlay } from "common";
import { LOADER_TYPES } from "app/services/OISService/constants";
import { useOIS } from "app/services/OISService/OISProvider";

const EProtocolTable = () => {
  const { t } = useTranslation();
  const { isLoading, eProtocolRecords } = useOIS();

  const columnConfig = getTableColumnHeaders();

  const NoEProtocolOverlay = () => (
    <NoRowsGridOverlay message={t("eProtocol.table.noRows")} />
  );

  return (
    <MuiBox id="eprotocol-activity-table-box" sx={{ width: "100%" }}>
      <MuiDataGrid
        slots={{
          loadingOverlay: LoadingGridOverlay,
          noRowsOverlay: NoEProtocolOverlay,
        }}
        autoHeight
        disableColumnMenu
        disableColumnResize
        disableColumnReorder
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        disableMultipleColumnsSorting
        disableRowSelectionOnClick
        pagination
        onPaginationModelChange={() => {
          window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
        }}
        loading={isLoading[LOADER_TYPES.EPROTOCOL_ACTIVITY]}
        rows={eProtocolRecords?.irbResources || []}
        getRowId={(row) => row.protocolNumber}
        columns={columnConfig}
        initialState={{ pagination: { paginationModel: { pageSize: 20 } } }}
        pageSizeOptions={[20, 50, 100, 500]}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "Mui-even" : "Mui-odd"
        }
        getRowHeight={() => "auto"}
        sx={tableStyles}
      />
    </MuiBox>
  );
};

export default EProtocolTable;
